export const PresetScope = {
  BUILTIN: 'builtin',
  GLOBAL: 'global',
  PROJECT: 'project',
} as const;

export type PresetScope = (typeof PresetScope)[keyof typeof PresetScope];

export interface Preset {
  id: string;
  name: string;
  description: string | null;
  icon: string;
  color: string | null;
  scope: PresetScope;
  model: string | null;
  maxTurns: number | null;
  maxBudgetUsd: number | null;
  permissionMode: string | null;
  allowedTools: string[] | null;
  systemPromptAppend: string | null;
  autoRestart: boolean | null;
  maxRetries: number | null;
  spawnMode: string | null;
  userId: string | null;
  projectId: string | null;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
}

export interface CreatePresetDto {
  name: string;
  description?: string;
  icon?: string;
  color?: string;
  scope?: PresetScope;
  model?: string;
  maxTurns?: number;
  maxBudgetUsd?: number;
  permissionMode?: string;
  allowedTools?: string[];
  systemPromptAppend?: string;
  autoRestart?: boolean;
  maxRetries?: number;
  spawnMode?: string;
  sortOrder?: number;
}
